import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-mee',
  templateUrl: './map-mee.component.html',
  styleUrls: ['./map-mee.component.sass']
})
export class MapMeeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById('divItems').scrollIntoView(true);
  }

}
